export default "__VITE_ASSET__DWU6nzi___"